// Заказы в договорах клиентов
import { create } from 'zustand';
import { getContractOrders, getContractOrdersParams, getOrderPayments, getOrderPaymentsParams } from 'services';

export const useContractOrdersStore = create((set) => ({
	contractOrdersList: [],
	contractOrderPayments: [], // оплаты
	contractById: {}, // заказ клиента
	loading: false,
	orderFilters: {},
	getContractOrders: async () => {
		set({ loading: true });
		const contractOrdersList = await getContractOrders();
		set({ contractOrdersList, loading: false });
	},
	// Запрос с параметрами
	getContractOrdersParams: async (filters) => {
		set({ loading: true });
		const contractOrdersList = await getContractOrdersParams(filters);
		set({ contractOrdersList, loading: false });
	},
	// Запрос с оплат
	getOrderPayments: async () => {
		set({ loading: true });
		const contractOrderPayments = await getOrderPayments();
		set({ contractOrderPayments, loading: false });
	},
	// Запрос оплат с параметрами
	getOrderPaymentsParams: async (filters) => {
		set({ loading: true });
		const contractOrderPayments = await getOrderPaymentsParams(filters);
		set({ contractOrderPayments, loading: false });
	},
	// Добавить фильтр
	addOrderFilter: (filter) => set((state) => ({ orderFilters: { ...state.orderFilters, ...filter } })),
	// Сбросить фильтры
	resetFilters: () => set({ orderFilters: {} }),
}))